<nz-select [(ngModel)]="selected" (nzOnSearch)="search($event)" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Наберите группу" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" nzCustomContent [nzLabel]="op.concatTitle" [nzValue]="op.id">
    <i nz-icon [nzType]="op.icon"></i> <span nz-title> {{ op.concatTitle }}</span>
  </nz-option>
</nz-select>
